module.exports = __webpack_public_path__ + "static/media/netflic-icons.a1f673e7.png";